//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import InspectionRecordPointDrawer from "./modules/InspectionRecordPointDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryProjectArchtList } from '@/api/api';
export default {
  name: "InspectionRecordPointList",
  mixins: [JeecgListMixin],
  components: {
    InspectionRecordPointDrawer: InspectionRecordPointDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/inspection/record/point',
      pageTitle: '巡检记录点',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'recordId',
        colName: 'record_id',
        title: '巡检记录',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'pointId',
        colName: 'point_id',
        title: '巡检点ID',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'val',
        colName: 'val',
        title: '巡检说明',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'realCoordinate',
        colName: 'real_coordinate',
        title: '真实坐标（预留）',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'coordinateDiff',
        colName: 'coordinate_diff',
        title: '预设与真实坐标差（预留）',
        align: "center",
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {},
  computed: {},
  methods: {}
};